"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Layout = void 0;
const react_1 = __importDefault(require("react"));
const react_router_dom_1 = require("react-router-dom");
const TabNavigation_1 = __importDefault(require("components/Dashboard/TabNavigation"));
const StyledHeader_1 = require("./StyledHeader");
const StyledContent_1 = require("./StyledContent");
const StyledContainer_1 = require("./StyledContainer");
const leftTab = {
    description: 'profile-link',
    label: 'Profile',
    link: '/settings/profile'
};
const middleTab = {
    description: 'security-link',
    label: 'Security',
    link: '/settings/security'
};
const rightTab = {
    description: 'communications-link',
    label: 'Communications',
    link: '/settings/communications'
};
const tabs = [leftTab, middleTab, rightTab];
const Layout = () => {
    return (react_1.default.createElement(StyledContainer_1.StyledContainer, null,
        react_1.default.createElement("div", null,
            react_1.default.createElement(StyledHeader_1.StyledHeader, null, "User Settings"),
            react_1.default.createElement(TabNavigation_1.default, { tabs: tabs })),
        react_1.default.createElement("div", null,
            react_1.default.createElement(StyledContent_1.StyledContent, null,
                react_1.default.createElement(react_router_dom_1.Outlet, null)))));
};
exports.Layout = Layout;
